import { OfficeContext, OfficeError } from '../types'

export const initializeOffice = (): Promise<OfficeContext> => {
  return new Promise((resolve, reject) => {
    if (typeof Office === 'undefined') {
      reject(new Error('Office.js is not loaded'))
      return
    }

    Office.onReady((info) => {
      resolve({
        host: info.host,
        platform: info.platform,
        version: Office.context.diagnostics?.version || 'unknown',
        isInitialized: true,
      })
    })
  })
}

export const getSelectedText = async (): Promise<string> => {
  return new Promise((resolve, reject) => {
    Office.context.document.getSelectedDataAsync(
      Office.CoercionType.Text,
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value)
        } else {
          reject(createOfficeError(result.error))
        }
      }
    )
  })
}

export const insertContent = async (
  content: string,
  coercionType: Office.CoercionType = Office.CoercionType.Text
): Promise<void> => {
  return new Promise((resolve, reject) => {
    Office.context.document.setSelectedDataAsync(
      content,
      { coercionType },
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve()
        } else {
          reject(createOfficeError(result.error))
        }
      }
    )
  })
}

export const showNotification = (
  message: string,
  title?: string
): void => {
  // Log notification - actual UI notification depends on Office host capabilities
  console.log(`${title || 'Notification'}: ${message}`)
}

export const createOfficeError = (error: Office.Error): OfficeError => {
  return {
    name: error.name,
    message: error.message,
    code: error.code,
  }
}

export const isOfficeInitialized = (): boolean => {
  return typeof Office !== 'undefined' && Office.context !== undefined
}

export const getDocumentUrl = (): string | undefined => {
  return Office.context.document?.url
}

export const getHostInfo = (): { host: string; platform: string } | null => {
  if (!isOfficeInitialized()) return null
  
  return {
    host: Office.context.host.toString(),
    platform: Office.context.platform.toString(),
  }
}

export const openDialog = (
  url: string,
  options?: Office.DialogOptions
): Promise<Office.Dialog> => {
  return new Promise((resolve, reject) => {
    Office.context.ui.displayDialogAsync(
      url,
      options || { width: 50, height: 50 },
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value)
        } else {
          reject(createOfficeError(result.error))
        }
      }
    )
  })
}